export { default } from './InputMessage'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/InputMessage/index.js